import { FC } from 'react';

import AddonCheckboxGroup from '@/components/ui/AddonCheckboxGroup';
import {
  CheckboxCard,
  CheckboxCardDescription,
  CheckboxCardHeader,
  CheckboxCardIndicator,
  CheckboxCardInfo,
  CheckboxCardPrice,
  CheckboxCardTitle,
} from '@/components/ui/CheckboxCard';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';

import { ADDON_PRICES, ADDON_TYPE } from '../schema';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ADDONS_NAME = 'addons';

interface Props {
  name?: string;
}

const AddonsCheckboxGroup: FC<Props> = ({ name = ADDONS_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const selected = (field.value ?? []) as string[];
        return (
          <FormItem>
            <FormControl>
              <div className="rounded-md bg-gray-200 p-[14px] md:p-6">
                <AddonCheckboxGroup>
                  <CheckboxCard
                    checked={selected.includes(ADDON_TYPE.PDF_INSTRUCTION)}
                    onCheckedChange={(checked: boolean) => {
                      field.onChange(
                        checked
                          ? [...selected, ADDON_TYPE.PDF_INSTRUCTION]
                          : selected.filter(
                              (v) => v !== ADDON_TYPE.PDF_INSTRUCTION
                            )
                      );
                    }}
                  >
                    <CheckboxCardHeader>
                      <CheckboxCardIndicator />
                      <CheckboxCardPrice>
                        {ADDON_PRICES[ADDON_TYPE.PDF_INSTRUCTION]} zł
                      </CheckboxCardPrice>
                    </CheckboxCardHeader>
                    <CheckboxCardInfo>
                      <CheckboxCardTitle>
                        {i18n.t('Instrukcja PDF')}
                      </CheckboxCardTitle>
                      <CheckboxCardDescription>
                        {i18n.t(
                          'Krótka instrukcja, która pokazuje, jak samodzielnie uzupełnić dokument. Dobra opcja, jeśli wybierasz szablon do samodzielnego wypełnienia i chcesz uniknąć błędów.'
                        )}
                      </CheckboxCardDescription>
                    </CheckboxCardInfo>
                  </CheckboxCard>
                  <CheckboxCard
                    checked={selected.includes(ADDON_TYPE.CONSULTATION)}
                    onCheckedChange={(checked: boolean) => {
                      field.onChange(
                        checked
                          ? [...selected, ADDON_TYPE.CONSULTATION]
                          : selected.filter(
                              (v) => v !== ADDON_TYPE.CONSULTATION
                            )
                      );
                    }}
                  >
                    <CheckboxCardHeader>
                      <CheckboxCardIndicator />
                      <CheckboxCardPrice>
                        {ADDON_PRICES[ADDON_TYPE.CONSULTATION]} zł
                      </CheckboxCardPrice>
                    </CheckboxCardHeader>
                    <CheckboxCardInfo>
                      <CheckboxCardTitle>
                        {i18n.t('Konsultacja z prawnikiem')}
                      </CheckboxCardTitle>
                      <CheckboxCardDescription>
                        {i18n.t(
                          'Prawnik omówi z Tobą sprawę i odpowie na pytania dotyczące dokumentu. Po zakupie skontaktujemy się z Tobą, żeby ustalić termin konsultacji.'
                        )}
                      </CheckboxCardDescription>
                    </CheckboxCardInfo>
                  </CheckboxCard>
                </AddonCheckboxGroup>
              </div>
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default AddonsCheckboxGroup;
